/**
 * Action used to set custom user properties.
 */
export const SET_DYNAMIC_BRANDING_DATA = 'SET_DYNAMIC_BRANDING_DATA';

/**
 * Action used to signal the customization failed.
 */
export const SET_DYNAMIC_BRANDING_FAILED = 'SET_DYNAMIC_BRANDING_FAILED';

/**
 * Action used to signal the branding elements are ready to be displayed.
 */
export const SET_DYNAMIC_BRANDING_READY = 'SET_DYNAMIC_BRANDING_READY';
